import * as React from 'react';
import { SyntheticEvent, useEffect, useRef } from 'react';

interface Props {
    labelText: string;
    invalidText: string;
    id: string;
    name: string;
    value?: string;
    onChange?: (name: string, value: string) => void;
    disabled?: boolean;
    maxLength?: number;
    pattern?: string;
    placeholder?: string;
    boldTitle?: boolean;
    validationMessage?: string;
    type?: string;
}

const ProfilePageInput = (props: Props) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const errorId = `${props.id}-error`;

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.setCustomValidity(props.validationMessage || '');
        }
    }, [props.validationMessage, props.value]);
    return (
        <div className="profile-page-input">
            <label htmlFor={props.id} className={props.boldTitle ? 'bold-profile-page-label' : ''}>
                {props.labelText}
            </label>
            <input
                id={props.id}
                ref={inputRef}
                name={props.name}
                type={props.type || 'text'}
                value={props.value ? props.value : ''}
                onChange={(e: SyntheticEvent<HTMLInputElement>) =>
                    props.onChange && props.onChange(props.name, e.currentTarget.value.toString())
                }
                className="form-control"
                disabled={!!props.disabled}
                maxLength={props.maxLength}
                required={true}
                pattern={props.pattern}
                placeholder={props.placeholder}
                aria-describedby={props.invalidText ? errorId : undefined}
            />
            {props.invalidText && (
                <div
                    id={errorId}
                    className="invalid-feedback profile-page-invalid-text"
                    role="alert"
                >
                    {props.invalidText}
                </div>
            )}
        </div>
    );
};

export default ProfilePageInput;



// WEBPACK FOOTER //
// ./src/components/common/form/ProfilePageInput.tsx